<div class="d-flex text-center flex-column message-dialog-container">
    <h1 mat-dialog-title>Messages</h1>
    <div mat-dialog-content class="message-dialog-content">
        <!-- Table Section (60% height) -->
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100 left-aligned-cells">

                <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef class="left-aligned-cell"> Id </th>
                                <td mat-cell *matCellDef="let element" class="left-aligned-cell"  [ngClass]="{'unread-message': !element.isRead}"> {{element.id}} </td>
                            </ng-container>

                             <ng-container matColumnDef="createDateTime">
                                <th mat-header-cell *matHeaderCellDef class="left-aligned-cell"> Date </th>
                                <td mat-cell *matCellDef="let element" class="left-aligned-cell" [ngClass]="{'unread-message': !element.isRead}">
                                    {{ element.createDateTime | date:'short' }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="messageType">
                                <th mat-header-cell *matHeaderCellDef class="left-aligned-cell"> Message Type </th>
                                <td mat-cell *matCellDef="let element" class="left-aligned-cell" [ngClass]="{'unread-message': !element.isRead}"> {{element.messageType}} </td>
                            </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row   *matRowDef="let row; columns: displayedColumns"  
                (click)="selectMessage(row)"  
                [class.selected-row]="selectedMessage === row" 
                [class.unread-row]="!row.isRead"></tr>
                </table>

        </div>
        
         <!--Text Area Section (40% height) - Full width -->
        <div class="text-area-container">
            <h3 class="text-left mb-2">Message Details</h3>
      
        <form [formGroup]="form" >
                <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Message Content</mat-label>
                        <textarea matInput 
                            placeholder="Message content will appear here" 
                            formControlName="message"
                                readonly 
                                rows="6"></textarea>
                        </mat-form-field>
            </form>


            
        </div>
    </div>
     <!-- Dialog actions -->
    <div mat-dialog-actions class="dialog-actions">
        <button type="button" class="btn btn-outline-primary btn-lg cancel-button" (click)="cancel()" data-cy-button="cancel">
            Close
        </button>
    </div>
</div>